import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

import { BoutonConfirmationComponent } from '~Components/bouton-confirmation/bouton-confirmation.component';

/**
 * Composant de la photo fiche relais
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent extends BaseComponent implements OnInit {
    @Input() titre: string;
    @Input() ouvert: boolean = false;
    @Input() afficherBoutons: boolean = true;
    @Input() afficherBoutonAnnuler: boolean = true;
    @Input() afficherBoutonAppliquer: boolean = true;

    @Input() boutonAnnuler: string = this.T('popup.bouton.annuler');
    @Input() boutonAppliquer: string = this.T('popup.bouton.appliquer');

    @Input() appliquerCallback: Function = () => {};
    @Input() annulerCallback: Function = () => { this.fermer(); };

    @Input() fermerCallback: Function = () => { return true; };
    @Input() ouvrirCallback: Function = () => { return true; };

    @Input("activerConfirmation") activerConfirmation: boolean = false;
    @Input("confirmationLibelle") confirmationLibelle: string = '';
    @Input("confirmationLibelleConfirmer") confirmationLibelleConfirmer: string = '';
    @Input("confirmationLibelleAnnuler") confirmationLibelleAnnuler: string = '';

    @ViewChild('boutonConfirmation', { static: false }) composantBoutonConfirmation: BoutonConfirmationComponent;

    /**
     * Fermer la popup en appuyant sur la touche 'Echap'
     */
    @HostListener('document:keydown.escape') onKeydownHandler() {
        if (this.ouvert) {
            this.fermer();
        }
    }

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Ouvrir la popup
     */
    public ouvrir() {
        if (this.ouvrirCallback()) {
            this.ouvert = true;
        }
    }

    /**
     * Fermer la popup
     */
    public fermer() {
        if (this.fermerCallback()) {
            this.ouvert = false;

            // R�initialise la confirmation
            this.resetConfirmation();
        }
    }

    /**
     * Annuler
     */
    public annuler() {
        this.annulerCallback();
    }

    /**
     * Appliquer
     */
    public appliquer() {
        this.appliquerCallback();
    }

    /**
     * R�initialiser la confirmation
     */
    public resetConfirmation() {
        // R�initialise la confirmation du composant de bouton de confirmation
        if (this.composantBoutonConfirmation) {
            this.composantBoutonConfirmation.resetConfirmation();
        }
    }
}
